export enum CmsMappedBlockWidth {
  NARROW = 'NARROW',
  FULL = 'FULL',
}
